import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import paths from 'routes/paths';
import { signin } from 'services/auth';

const forgotPasswordPaths = {
  simple: paths.simpleForgotPassword,
  split: paths.splitForgotPassword,
  card: paths.cardForgotPassword
};

const LoginForm = ({ hasLabel = false, layout = 'simple' }) => {
  const navigate = useNavigate();

  // State
  const [formData, setFormData] = useState({
    // email: 'josepabloosioavila@gmail.com',
    // password: '123',
    email: '',
    password: '',
    remember: false
  });

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();
    console.log('formData', formData);
    // signin(formData.email, formData.password)
    //   .then(response => {
    //     if (response.result) {
    //       // Guarda el token en localStorage
    //       const token = response.token;
    //       localStorage.setItem('authToken', token);

    //       toast.success(`Bienvenido, ${response.user_name}`, {
    //         theme: 'colored'
    //       });

    //       // Redirige al usuario a la ruta "/"
    //       navigate('/');
    //     } else {
    //       // Muestra el mensaje de error devuelto por la API
    //       toast.error(response.msg || 'Error al iniciar sesión', {
    //         theme: 'colored'
    //       });
    //     }
    //   })
    //   .catch(err => {
    //     // Manejo de errores inesperados
    //     toast.error('Ocurrió un error inesperado. Por favor, inténtalo de nuevo.', {
    //       theme: 'colored'
    //     });
    //   });
    try {
      const response = await signin(formData.email, formData.password);

      if (response.result) {
        // Guarda el token en localStorage
        const token = response.token;
        localStorage.setItem('authToken', token);

        toast.success(`Bienvenido, ${response.user_name}`, {
          theme: 'colored'
        });

        // Redirige al usuario a la ruta "/"
        navigate('/');
      } else {
        // Muestra el mensaje de error devuelto por la API
        toast.error(response.msg || 'Error al iniciar sesión', {
          theme: 'colored'
        });
      }
    } catch (err) {
      // Manejo de errores inesperados
      toast.error(
        'Ocurrió un error inesperado. Por favor, inténtalo de nuevo.',
        {
          theme: 'colored'
        }
      );
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Correo electrónico</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Correo electrónico' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Contraseña</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Contraseña' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>
      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={e =>
                setFormData({
                  ...formData,
                  remember: e.target.checked
                })
              }
            />
            <Form.Check.Label className="mb-0 text-700">
              Recuérdame
            </Form.Check.Label>
          </Form.Check>
        </Col>
        <Col xs="auto">
          <Link className="fs-10 mb-0" to={forgotPasswordPaths[layout]}>
            ¿Olvidaste tu contraseña?
          </Link>
        </Col>
      </Row>
      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password}
        >
          Iniciar sesión
        </Button>
      </Form.Group>
    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

export default LoginForm;
